import React, { Component } from 'react';

import { Tag,Row, Col,Menu,Pagination,message,Breadcrumb,Icon,BackTop } from 'antd';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import * as Types from './../../../utils/questionType'
import {SUBJECT} from './../../../utils/questionManageType'
import {view as EditDel} from './editDel'
import Question from '../../../entry_question_editor/question/question_view/view';
import {action} from './';

import axios from 'axios';
import API from '../../../API/api'
import BatchPushImage from '../mission_list/batchPushImage/batchPushImage'
import BatchPushQuestion from '../mission_list/batchPushQuestion/batchPushQuestion'

class MissionDetail extends Component{
    state = {
        name:'',
        chapter:'',
        clerk:'',
        total:1,
        listFilterNow:'0',//全部 审核中 返工。
        page:1,
        pagesize:localStorage.getItem('questionlist_pagesize')||10,
        isVerify:false,
        task_id:'',
    }
    listFilter =(val)=>{//筛选改变
        let {listFilterNow} = this.state
        if(listFilterNow===val.key) return
        this.setState({listFilterNow:val.key,page:1})
        setTimeout(()=>{
            this.getQuestionList()
        },0)
    }
    onPageChange =(val)=>{//翻页
        this.setState({page:val})
        setTimeout(()=>{
            this.getQuestionList()
            document.querySelector('.questionListScroll').scrollTop=0
        },0)
    }
    getQuestionList=()=>{
        let { getAllQuestionList,getEntryingQuestionList,getPassQuestionList, getReworkQuestionList} = this.props;
        let {listFilterNow,page,pagesize} = this.state
        const callback = () => {
            let {data} = this.props
            this.setState({total:data.total,page:data.page})
        }

        let task_id = window.location.href.split('/').pop()
        if(listFilterNow==='0'){
            getAllQuestionList({task_id, page, pagesize}, callback)
        }
        else if(listFilterNow==='1'){
            getEntryingQuestionList({task_id, page, pagesize},callback )
        }
        else if(listFilterNow==='2'){
            getPassQuestionList({task_id, page, pagesize}, callback)
        }
        else if(listFilterNow==='3'){
            getReworkQuestionList({task_id, page, pagesize},callback)
        }
        this.setState({task_id})
    }

    refresh=()=>{
        this.getQuestionList()
    }
    componentDidMount(){
        this.getQuestionList()
        axios.post(API.GET_TASK_INFO,{task_id:window.location.href.split('/').pop()}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                if(res.data.stage=='21'){//是审核中的任务显示合格返工按钮
                    this.state.isVerify=true
                }
                if(res.data.stage=='12'){//是录入中的任务显示添加题目按钮
                    this.state.canAddQuestion=true
                }
                this.setState({
                    name:res.data.name,
                    clerk:res.data.entry_user,
                    chapter:res.data.name_ext,
                    isVerify:this.state.isVerify,
                    canAddQuestion:this.state.canAddQuestion,
                    source_type:res.data.source_type,
                })
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    render(){
        const {data,list} = this.props
        // console.log(list)
        let addQuestionUrl = window.location.origin+`/question.html#/${window.location.href.split('/').pop()}/fillin/`
        return(
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <Link to="/questionbox">题盒子</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>任务详情</span>
                        <span>（&nbsp;{window.location.href.split('/').pop()}&nbsp;）</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <BackTop visibilityHeight={100} ></BackTop>
                <Row style={{marginTop:15}}>
                    <Col span={18}>
                        <div style={{width:'100%',borderRadius:4,border:'solid 1px #999999',padding:'8px 15px'}}>
                            {this.state.name && <Tag color="#108ee9" style={{fontSize:14,margin:'3px 5px'}}>{this.state.name}</Tag>}
                            {this.state.chapter && <Tag color="#108ee9" style={{fontSize:14,margin:'3px 5px'}}>{this.state.chapter}</Tag>}
                            {/*{this.state.clerk && <Tag color="#108ee9" style={{fontSize:14,margin:'3px 5px'}}>录入员：{this.state.clerk}</Tag>}*/}
                        </div>
                    </Col>
                    <Col span={6}>
                        <div style={{height:40,lineHeight:'40px'}}>
                            {
                                this.props.user.role_qbox&&
                                this.props.user.role_qbox.buttons&&
                                this.props.user.role_qbox.buttons.questionAdd&&
                                    this.state.canAddQuestion&&
                                    <div>
                                        <a className="ant-btn ant-btn-primary" style={{fontSize: 14,marginLeft:20,verticalAlign:'middle',lineHeight:'28px'}} href={addQuestionUrl} target="_blank">添加题目</a>
                                        {
                                            this.props.user.role_qbox.buttons.batchAdd===1&&
                                            (this.props.user.subject===SUBJECT.MATH)&&
                                            this.state.source_type=='4'&&
                                            <BatchPushQuestion task_id={window.location.href.split('/').pop()}/>
                                        }
                                        {
                                            this.props.user.role_qbox.buttons.batchUpload===1&&
                                            (this.props.user.subject===SUBJECT.CHINESE||
                                            this.props.user.subject===SUBJECT.ENGLISH)&&
                                            <BatchPushImage/>
                                        }

                                    </div>

                            }
                        </div>
                    </Col>
                </Row>
                <Row style={{marginTop:15}}>
                    <div style={{fontSize:12}}>
                        <Menu
                            selectedKeys={[this.state.listFilterNow]}
                            onClick={(e)=>{this.listFilter(e)}}
                            mode="horizontal"
                            style={{backgroundColor:'#f5f6fa'}}
                        >
                            <Menu.Item key="0">全部</Menu.Item>
                            <Menu.Item key="1">未审核</Menu.Item>
                            <Menu.Item key="2">审核通过</Menu.Item>
                            <Menu.Item key="3">返工</Menu.Item>
                        </Menu>
                    </div>
                </Row>
                <Row style={{height:"100%",position:'relative',zIndex:2}} className={'questionList'}>
                    {
                        !!list.length ?
                            list.map((v, k) =>
                                <div key={v.question_id} style={{marginBottom: '30px',position:'relative'}}>

                                    <div className={'question'} style={{    paddingRight: 110,minHeight: 330}}>
                                        {/*返工原因展示*/}
                                        {v.mark &&v.mark!==''&&
                                        <div style={{textAlign:'center',fontSize:'15px',marginBottom:'15px'}}>
                                            <span color="#f50"
                                                  style={{
                                                      fontSize:14,
                                                      maxWidth:'100%',
                                                      backgroundColor: 'rgb(255, 85, 0)',
                                                      color:'#fff',
                                                  }}
                                            ><span>返工原因：</span>
                                                <span
                                                    style={{display: 'inline-block',
                                                        maxwidth: 'calc(100% - 100px)',
                                                        wordBreak: 'break-all'}}
                                                >
                                                <span style={{backgroundColor: 'rgb(255, 85, 0)',textAlign:'left'}}>
                                                        {v.mark}
                                                    </span>
                                                </span>
                                            </span>
                                        </div>
                                        }
                                
                                        <Question data={v} num={(this.state.page-1)*this.state.pagesize+k}/>


                                    </div>
                                    {
                                        Types.NUM_TO_TYPE[v.type_show]&&
                                        <EditDel question={v} refresh={this.refresh} isVerify={this.state.isVerify}/>
                                    }
                                </div>
                            ) :
                            <div style={{fontSize: "16px", height: "30px", marginBottom: "50px"}}>
                                <p style={{paddingTop: 15, paddingLeft: 50, color: 'green'}}>暂无题目</p>
                            </div>
                    }
                </Row>
                {
                    this.state.total>0 &&
                    <Row style={{marginTop:15,marginBottom:20,textAlign:'right'}}>
                        <Pagination current={this.state.page}
                                    total={this.state.total}
                                    onChange={ this.onPageChange }

                                    showSizeChanger
                                    showQuickJumper
                                    onShowSizeChange={ (current, pagesize)=>{localStorage.setItem('questionlist_pagesize',pagesize);this.setState({pagesize});this.onPageChange(1)} }
                                    pageSizeOptions={['10','20','30','40']}
                                    pageSize={+this.state.pagesize}
                        />
                    </Row>
                }
            </div>

        );
    }

}

const mapStateTopProps = (state) => {
    const questions = state.questionBox.missionDetail;
    return {
        data:questions.data,
        list:questions.data.list,
        delQuestionstate:questions.delQuestionstate,
        user:state.user
    };
}
const mapDispatchToProps = dispatch => {
    return {
        getAllQuestionList:(val,callback)=>{
            dispatch(action.getAllQuestionList(val,callback))
        },
        getEntryingQuestionList:(val,callback)=>{
            dispatch(action.getEntryingQuestionList(val,callback))
        },
        getPassQuestionList:(val,callback)=>{
            dispatch(action.getPassQuestionList(val,callback))
        },
        getReworkQuestionList:(val,callback)=>{
            dispatch(action.getReworkQuestionList(val,callback))
        },
    }
};
export default connect(mapStateTopProps,mapDispatchToProps)(MissionDetail)




// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_detail/view.js